<template>
  <div class="text-xs-center">
    <template v-if="selectedBot">
      <v-layout>
        <template v-for="social in livechatChannelOptions">
          <v-flex
            :key="`social_${social.value}`"
            style="position: relative"
            :style="{ width: `${100 / livechatChannelOptions.length + 1}%` }"
          >
            <LivechatTabButton
              depressed
              class="pa-1"
              :social="social"
              dark
              @changeApp="changeApp(social.fullValueForUse)"
            >
              <em :class="social.icon" />
            </LivechatTabButton>
            <div
              v-if="
                Object.prototype.hasOwnProperty.call(notify, social.fullValueForUse) &&
                notify[social.fullValueForUse] &&
                isTicketAdmin
              "
              class="newnotifycount"
            >
              {{ numberFormat(notify[social.fullValueForUse]) }}
            </div>
          </v-flex>
        </template>

        <v-flex :style="{ width: `${100 / livechatChannelOptions.length + 1}%` }">
          <button
            depressed
            style="border-radius: 0; width: 100%; position: relative"
            class="ma-0 pa-0 py-3"
            @click="$emit('onsearch', true)"
          >
            <v-icon>search</v-icon>
          </button>
        </v-flex>
      </v-layout>
    </template>
    <div style="position: relative">
      <template v-if="currentLivechatExpireTime > 0">
        <div class="px-1 info caption white--text">
          แพคเกจรวมแชทคงเหลือ
          <countdown :time="currentLivechatExpireTime * 1000">
            <template slot-scope="props">
              <template v-if="props.days">
                {{ props.days | numberFormat }}
                <span class="small">{{ $t('Days') }}</span>
              </template>
              <template v-else-if="props.hours > 0">
                {{ props.hours | numberFormat }}
                <span class="small">{{ $t('Hours') }}</span>
              </template>
              <template v-else-if="props.minutes > 0">
                {{ props.minutes | numberFormat }}
                <span class="small">{{ $t('Minutes') }}</span>
              </template>
              <template v-else>
                {{ props.seconds | numberFormat }}
                <span class="small">{{ $t('Seconds') }}</span>
              </template>
            </template>
          </countdown>
        </div>
      </template>
      <v-layout>
        <v-flex>
          <v-tabs
            id="usertype"
            color="grey lighten-3"
            :value="$store.state.livechat.type"
            :slider-color="$vuetify.theme.primary"
            @change="changeType"
          >
            <v-tab :key="'admin'" ripple :href="'#admin'" style="position: relative">
              <div>
                {{ $t('Admin') }}
                <div
                  v-if="chatnotify && chatnotify.admin && chatnotify.admin != '0' && isTicketAdmin"
                  class="newnotifycount"
                >
                  {{ numberFormat(chatnotify.admin) }}
                </div>
              </div>
            </v-tab>
            <v-tab
              v-if="showChatbotTab"
              :key="'bot'"
              ripple
              :href="'#bot'"
              style="position: relative"
            >
              <div>
                {{ $t('chatbot') }}
                <div
                  v-if="
                    chatnotify &&
                    chatnotify.bot &&
                    chatnotify.bot != '0' &&
                    isTicketAdmin &&
                    selectedBot.pageid != '100207768987988'
                  "
                  class="newnotifycount"
                >
                  {{ numberFormat(chatnotify.bot) }}
                </div>
              </div>
            </v-tab>
          </v-tabs>
        </v-flex>
        <v-flex shrink>
          <div style="background-color: #eeeeee">
            <v-btn icon @click="showSetting = true">
              <v-icon>settings</v-icon>
            </v-btn>
            <cooldown :delay="10" cname="refresh_chat_user" @onLoad="onRefreshChatUser">
              <template #default="{ zloading, onClick, show }">
                <v-btn v-if="show" icon :loading="zloading" @click="onClick">
                  <v-icon>refresh</v-icon>
                </v-btn>
              </template>
              <template #countdown="{ show, delaytime, onCountdownEnd }">
                <template v-if="show && delaytime !== true && delaytime > 0">
                  <v-btn v-if="show" icon :loading="true">
                    <v-icon>refresh</v-icon>
                    <countdown :time="delaytime * 1000" @end="onCountdownEnd"> </countdown>
                  </v-btn>
                </template>
              </template>
            </cooldown>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <v-dialog v-model="showSetting" scrollable persistent max-width="500px">
      <v-card>
        <v-card-title class="pb-0">
          <v-spacer /><v-btn icon small @click="showSetting = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <template v-if="$store.state.livechat.app == 'line'">
          <v-card-text class="pt-0">
            <LineQuota></LineQuota>
          </v-card-text>
          <v-divider />
        </template>
        <v-card-text>
          <v-layout>
            <v-flex style="display: flex; align-items: center"> ตั้งอ่านแล้วทั้งหมด </v-flex>
            <v-btn variant="flat" small color="primary" @click="handleReadAll">
              อ่านแล้วทั้งหมด
            </v-btn>
          </v-layout>
        </v-card-text>
        <v-divider />
        <v-card-text>
          <v-layout>
            <v-flex>
              <toggle-button
                class="mt-2"
                :value="mute"
                :sync="true"
                :color="$vuetify.theme.success"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
                @change="toggleMute"
              />
              <span style="vertical-align: -webkit-baseline-middle">ปิดการแจ้งเตือนด้วยเสียง</span>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Cooldown from '@/components/elements/Cooldown'
import LineQuota from './LineQuota'
import LivechatSocialChannel from './LivechatSocialChannelMixin'
import LivechatTabButton from './LivechatTabButton'
import { PAGE } from '@/constants/page.js'
import { ToggleButton } from 'vue-js-toggle-button'
import chatlogApi from '@/api/chatlog'

export default {
  components: {
    Cooldown,
    LineQuota,
    LivechatTabButton,
    ToggleButton
  },
  mixins: [LivechatSocialChannel],
  props: ['newchatnotify'],
  data() {
    return {
      mute: false,
      showSetting: false,
      readAllLoading: false
    }
  },
  computed: {
    test() {
      return this.$store.state.privilege.view_ticket
    },
    isTicketAdmin() {
      if (
        this.selectedBot.theme == 'ticket' ||
        this.$store.state.ticketThemeList.includes(this.selectedBot.theme) ||
        this.$store.state.ticketPageid.includes(this.selectedBot.pageid)
      ) {
        if (
          this.selectedBot.pageid == '102549712095297' ||
          this.selectedBot.pageid == '105387828535129'
        ) {
          return true
        }
        return (
          !this.$store.state.privilege.view_ticket ||
          this.$store.state.privilege.view_ticket == 'all'
        )
      } else return true
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      searchlist: 'getLivechatSearching',
      astonAdmins: 'getAstonAdmins',
      loadingAstonAdmin: 'getLoadingAstonAdmins',
      livechat: 'livechat'
    }),
    currentLivechatExpireTime() {
      var bot = this.botlist.find((el) => {
        return el.pageid == this.$store.state.livechat.pageid
      })
      if (bot && bot.livechat_expireat != null) {
        var now = moment()
        var date = moment(bot.livechat_expireat)
        return parseInt(now.diff(date, 'seconds'))
      } else return null
    },
    chatnotify() {
      if (this.$store.state.livechat.app == 'facebook')
        return {
          admin: this.newchatnotify.facebook_admin,
          bot: this.newchatnotify.facebook_bot
        }
      else if (this.$store.state.livechat.app == 'line')
        return {
          admin: this.newchatnotify.line_admin,
          bot: this.newchatnotify.line_bot
        }
      else {
        return null
      }
    },
    notify() {
      return {
        facebook:
          this.newchatnotify.facebook_bot || this.newchatnotify.facebook_admin
            ? parseFloat(this.newchatnotify.facebook_bot) +
              parseFloat(this.newchatnotify.facebook_admin)
            : '',
        instagram:
          this.newchatnotify.instagram_bot || this.newchatnotify.instagram_admin
            ? parseFloat(this.newchatnotify.instagram_bot) +
              parseFloat(this.newchatnotify.instagram_admin)
            : '',
        line:
          this.newchatnotify.line_bot || this.newchatnotify.line_admin
            ? parseFloat(this.newchatnotify.line_bot) + parseFloat(this.newchatnotify.line_admin)
            : '',
        webchat:
          this.newchatnotify.webchat_bot || this.newchatnotify.webchat_admin
            ? parseFloat(this.newchatnotify.webchat_bot) +
              parseFloat(this.newchatnotify.webchat_admin)
            : '',
        app:
          this.newchatnotify.app_bot || this.newchatnotify.app_admin
            ? parseFloat(this.newchatnotify.app_bot) + parseFloat(this.newchatnotify.app_admin)
            : ''
      }
    },
    facebooknotify() {
      if (this.newchatnotify.facebook_bot || this.newchatnotify.facebook_admin) {
        return (
          parseFloat(this.newchatnotify.facebook_bot) +
          parseFloat(this.newchatnotify.facebook_admin)
        )
      } else return ''
    },
    linenotify() {
      if (this.newchatnotify.line_bot || this.newchatnotify.line_admin) {
        return parseFloat(this.newchatnotify.line_bot) + parseFloat(this.newchatnotify.line_admin)
      } else return ''
    },
    webchatnotify() {
      if (this.newchatnotify.webchat_bot || this.newchatnotify.webchat_admin) {
        return (
          parseFloat(this.newchatnotify.webchat_bot) + parseFloat(this.newchatnotify.webchat_admin)
        )
      } else return ''
    },
    appnotify() {
      if (this.newchatnotify.app_bot || this.newchatnotify.app_admin) {
        return parseFloat(this.newchatnotify.app_bot) + parseFloat(this.newchatnotify.app_admin)
      } else return ''
    },
    showChatbotTab() {
      if (
        [...PAGE.RATCHTHANI].includes(this.selectedBot.pageid) &&
        this.$store.state.privilege &&
        this.$store.state.privilege.role === 'staff'
      ) {
        return false
      } else if (
        [...PAGE.KMB].includes(this.selectedBot.pageid) &&
        this.$store.state.privilege &&
        this.$store.state.privilege.role === 'agent'
      ) {
        return false
      } else {
        return true
      }
    }
  },
  mounted() {
    if (localStorage.getItem('muteChat') == null) {
      this.mute = false
    } else {
      this.mute = JSON.parse(localStorage.getItem('muteChat'))
    }
  },
  methods: {
    async handleReadAll() {
      try {
        this.readAllLoading = true
        await chatlogApi.putReadAllChat({
          page_id: this.livechat.pageid,
          tab: this.livechat.type === 'bot' ? 'chatbot' : this.livechat.type, // admin, chatbot
          channel: this.livechat.app // line, facebook
        })
        this.$emit('refresh')
        this.showSetting = false
        await this.$swal({
          title: 'อัพเดทสำเร็จ',
          type: 'success',
          confirmButtonText: this.$t('Confirm')
        })
        this.$store.dispatch('livechatnotiunread')
      } catch (error) {
        console.error(error)
        await this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          confirmButtonText: this.$t('Confirm')
        })
      } finally {
        this.readAllLoading = false
      }
    },
    toggleMute() {
      this.mute = !this.mute
      localStorage.setItem('muteChat', this.mute)
    },
    changeApp(type) {
      this.$store.commit('SET_LIVECHAT_APP', type)
      this.$store.dispatch('updateLivechatUser', null)
      this.updateRoute()
    },
    changeType(name) {
      this.$store.commit('SET_LIVECHAT_TYPE', name)
      this.$store.dispatch('updateLivechatUser', null)
      this.updateRoute()
    },
    onRefreshChatUser(payload) {
      this.$store.dispatch('forceLoadLastestUsers')
      this.updateRoute()
      if (payload) payload.callback()
    },
    updateRoute: function () {
      var query = { ...this.$route.query }
      query.app = this.$store.state.livechat.app
      query.user = this.$store.state.livechat.type

      this.$router.push({
        name: 'allinonechat',
        path: '/allinonechat',
        query: query
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatTab.vue